var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('font',{staticClass:"engAndTrans"},[_vm._v(" "+_vm._s(_vm.value)+" "),_c('font',{staticClass:"engAndTrans englishVersion notranslate",attrs:{"translate":"no"}},[_vm._v(" - "+_vm._s(_vm.value)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }